import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { DashboardPage } from './pages/DashboardPage';
import { GalleryDetailPage } from './pages/GalleryDetailPage';
import { LandingPage } from './pages/LandingPage';
import { PublicGalleryPage } from './pages/PublicGalleryPage';
import { SignupPage } from './pages/SignupPage';
import { BookingsPage } from './pages/BookingsPage';
import { PublicBookingPage } from './pages/PublicBookingPage';
import { BookingStatusPage } from './pages/BookingStatusPage';
import { BookingActionPage } from './pages/BookingActionPage';
import { SettingsPage } from './pages/SettingsPage';
import { useAuth } from './lib/auth';
import { EnvironmentBadge } from './components/EnvironmentBadge';

export function App() {
  return (
    <>
      <EnvironmentBadge />
      <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/signup" element={<SignedOutRoute><SignupPage /></SignedOutRoute>} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/bookings" element={<ProtectedRoute><BookingsPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/galleries/:galleryId" element={<ProtectedRoute><GalleryDetailPage /></ProtectedRoute>} />
      <Route path="/g/:photographerSlug/:gallerySlug" element={<PublicGalleryPage />} />
      <Route path="/book/:photographerSlug" element={<PublicBookingPage />} />
      <Route path="/book/status/:token" element={<BookingStatusPage />} />
      <Route path="/book/action/:token" element={<BookingActionPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function HomeRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return <FullScreenStatus label="Loading" />;
  }
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <LandingPage />;
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return <FullScreenStatus label="Loading" />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function SignedOutRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return <FullScreenStatus label="Loading" />;
  }
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
}

function FullScreenStatus({ label }: { label: string }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-bone text-ink">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-ink/20 border-t-ink" aria-label={label} />
    </main>
  );
}
